import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {message as Amessage} from 'antd';
import importAllImg from "../helpers/import-all-imgs";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));


function contactUs(params) {
  const url = `https://udty.tech/api/v3/npf`;
  const myHeaders = new Headers();
  myHeaders.append("content-type", "application/json");

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(params),
  };

  return fetch(url, requestOptions)
    .then((data) => {
      return data;
    })
    .catch(function (err) {
      throw err;
    });
}


function ContactUs() {

  const { formatMessage } = useIntl();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [topic, setTopic] = useState('');

  const fm = id => formatMessage({id});

  const submit = e => {
    e.preventDefault();
    if (!name) return;
    if (!email) return
    const params = {name, email, message, topic};

    contactUs(params).then(res => {
      Amessage.success('success');
    }, rej => Amessage.error(JSON.stringify(rej)));
  };

  return (
    <div>
      {/* Header Section - Mobile */}
      <div
        className="block md:hidden"
      >
        <img className='w-full' src={imgs['Group 3035.png']} />
      </div>

      {/* Dark Green Banner - Mobile */}
      <div className="block md:hidden bg-[#354402] py-6 px-[5%]">
        <div className="font-['Bebas_Neue'] text-white text-3xl mb-2">
          {fm('Contact Us')}
        </div>
        <div className="text-white text-base">
          {fm('Have a project to share?')}
        </div>
        <div className="text-white text-base">
          {fm('Interested in building a better world with us?')}
        </div>
      </div>

      {/* Header Section - Desktop */}
      <div className="hidden md:block  mt-[90px] bg-[#354402] py-10 px-[7.5%]">
        <div className="font-['Bebas_Neue'] text-white text-[50px] mb-2">
          {fm('Contact Us')}
        </div>
        <div className="text-white text-lg">
          {fm('Have a project to share?')}
        </div>
        <div className="text-white text-lg">
          {fm('Interested in building a better world with us?')}
        </div>
      </div>

      {/* Content Section */}
      <div className="w-full mx-auto  md:py-0 flex flex-col md:flex-row gap-8 md:gap-0">
        {/* Left Column - Image (Desktop only) */}
        <div className="hidden md:block md:w-[50%]">
          <img
            src={imgs['Group 3034.png']}
            alt="Contact us"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Right Column - Contact Form */}
        <form
          className="w-full bg-[#F5F4EE] md:w-[50%] px-5 md:px-0"
          onSubmit={submit}
        >
          <div className="bg-[#F5F4EE] p-6 md:p-12">
            <div className="font-['Open_Sans'] font-semibold text-base text-[#828282] mb-2">
              Your Name <span className="text-red-500">*</span>
            </div>
            <input
              value={name}
              onChange={e => setName(e.target.value)}
              required
              className="w-full h-[54px] md:h-[54px] text-base text-[#828282] pl-4 md:pl-[18px] mb-6 bg-white rounded border-none focus:outline-none"
              placeholder={fm('Name (required)')}
            />

            <div className="font-['Open_Sans'] font-semibold text-base text-[#828282] mb-2">
              Email Address <span className="text-red-500">*</span>
            </div>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="w-full h-[54px] md:h-[54px] text-base text-[#828282] pl-4 md:pl-[18px] mb-6 bg-white rounded border-none focus:outline-none"
              placeholder={fm('Email (required)')}
            />

            <div className="font-['Open_Sans'] font-semibold text-base text-[#828282] mb-2">
              {fm('Topic')}
            </div>
            <input
              value={topic}
              onChange={e => setTopic(e.target.value)}
              className="w-full h-[54px] md:h-[54px] text-base text-[#828282] pl-4 md:pl-[18px] mb-6 bg-white rounded border-none focus:outline-none"
              placeholder={fm('Topic')}
            />

            <div className="font-['Open_Sans'] font-semibold text-base text-[#828282] mb-2">
              Your Message <span className="text-red-500">*</span>
            </div>
            <textarea
              value={message}
              onChange={e => setMessage(e.target.value)}
              required
              className="w-full h-[208px] md:h-[250px] text-base text-[#828282] p-4 md:pt-9 md:px-[18px] mb-6 bg-white rounded border-none focus:outline-none resize-none"
              placeholder={fm('Message')}
            />

            <button
              type='submit'
              className="w-[165px] h-[44px] bg-[#354402] rounded text-white font-bold text-sm uppercase flex items-center justify-center drop-shadow-[0px_4px_4px_rgba(0,0,0,0.25)] hover:bg-[#2a3501] transition-colors mx-auto md:mx-0"
            >
              {fm('SUBMIT')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ContactUs;
